import { Clock, CalendarHeart, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "./data";

const POINTS = [
    { icon: Clock, title: "Limited bookings per day", desc: "Every bride gets our full attention — so we take only a few weddings daily." },
    { icon: CalendarHeart, title: "Wedding dates fill fast – reserve now", desc: "Muhurtham dates for this season are booking out weeks in advance." },
];

export const UrgencySection = () => (
    <section data-testid="urgency-section" className="bg-[#FAF0EC] py-20">
        <div className="mx-auto max-w-6xl px-5">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Don't wait</p>
            <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#2C2A29] sm:text-5xl">
                Your wedding date won't wait for you
            </h2>
            <div className="mt-12 grid gap-6 md:grid-cols-2">
                {POINTS.map(({ icon: Icon, title, desc }) => (
                    <div
                        key={title}
                        className="flex gap-5 rounded-sm border border-[#D4AF37]/20 bg-white p-8"
                    >
                        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#E6B8B8]/30">
                            <Icon className="h-6 w-6 text-[#D4AF37]" />
                        </span>
                        <div>
                            <h3 className="font-serif text-2xl font-medium text-[#2C2A29]">{title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-[#5A5652]">{desc}</p>
                        </div>
                    </div>
                ))}
            </div>
            <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="urgency-whatsapp-button"
                className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-8 py-3.5 text-sm font-extrabold text-white shadow-lg transition-transform duration-200 hover:-translate-y-1"
            >
                <MessageCircle className="h-5 w-5" />
                Check Your Date on WhatsApp
            </a>
        </div>
    </section>
);
